import axios from "axios";
import { newAbortSignal } from "../../utils";
import { SessionStore } from "../../types/store/SessionStore";
import { ManagerLevel } from "../../types/model/account";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/account`;

export const getManagerLevel = async (
  accountId: number,
  projectId?: number,
  activityId?: number,
  procedureId?: number,
): Promise<ManagerLevel> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const finalURL = `${BASE_URL}/${accountId}/manager-level`;

  return await axios
    .get<ManagerLevel>(finalURL, {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      params: {
        projectId,
        activityId,
        procedureId,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(
              Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
            )
          : AbortSignal.timeout(
              Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
            ),
    })
    .then((response) => response.data);
};
